import React, { useState } from "react";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

function JsonNode({ name, value, depth = 0, defaultOpen = depth < 1 }) {
  const [open, setOpen] = useState(defaultOpen);

  if (value === null || value === undefined) {
    return (
      <div className="json-line" style={{ paddingLeft: depth * 16 }}>
        {name !== null && <span className="json-key">{name}: </span>}
        <span className="json-null">null</span>
      </div>
    );
  }

  if (typeof value !== "object") {
    const cls =
      typeof value === "string"
        ? "json-string"
        : typeof value === "number"
          ? "json-number"
          : "json-boolean";
    return (
      <div className="json-line" style={{ paddingLeft: depth * 16 }}>
        {name !== null && <span className="json-key">{name}: </span>}
        <span className={cls}>{JSON.stringify(value)}</span>
      </div>
    );
  }

  const isArray = Array.isArray(value);
  const entries = isArray
    ? value.map((v, i) => [String(i), v])
    : Object.entries(value);
  const preview = isArray ? `[${value.length}]` : `{${entries.length}}`;

  return (
    <div className="json-node">
      <div
        className="json-line json-collapsible"
        style={{ paddingLeft: depth * 16 }}
        onClick={() => setOpen((v) => !v)}
        role="button"
        tabIndex={0}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") setOpen((v) => !v);
        }}
      >
        <span className="json-toggle">{open ? <ExpandMoreIcon fontSize="inherit" /> : <ChevronRightIcon fontSize="inherit" />}</span>
        {name !== null && <span className="json-key">{name}: </span>}
        <span className="json-preview">{preview}</span>
      </div>
      {open &&
        entries.map(([k, v]) => (
          <JsonNode key={`${depth}-${k}`} name={isArray ? null : k} value={v} depth={depth + 1} defaultOpen={depth < 0} />
        ))}
    </div>
  );
}

export default function JsonResponseViewer({ data, errors }) {
  if (!data && !errors) {
    return (
      <div className="json-empty">
        Ejecutá una query para ver la respuesta acá.
      </div>
    );
  }

  return (
    <div className="json-response-viewer">
      {errors?.length > 0 && (
        <div className="json-errors">
          {errors.map((err, i) => (
            <div key={i} className="json-error-line">
              {typeof err === "string" ? err : err.message || JSON.stringify(err)}
            </div>
          ))}
        </div>
      )}
      {data && <JsonNode name={null} value={data} depth={0} defaultOpen />}
    </div>
  );
}
